// Человеческий текст ошибки.
//
// Правило, ради которого файл существует: пользователю нельзя показывать то,
// что бросил fetch. Прежде экраны печатали `Ошибка: {String(error)}`, а внутри
// лежала строка вида `POST /api/debts/... → 500 Internal Server Error: {...}`.
// Это не сообщение, это дамп.
//
// Текст объясняет, что произошло и что делать, и не извиняется. Техническая
// часть остаётся в полях ApiError — её место в логах, а не на экране.

import { ApiError } from '../api/client';

/**
 * Короткое сообщение по ошибке. `fallback` описывает конкретное действие
 * («Не удалось записать платёж») и используется там, где по коду ответа
 * ничего умнее не скажешь.
 */
export function humanError(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    switch (true) {
      case err.status === 401 || err.status === 403:
        return 'Нет доступа. Откройте приложение заново из Telegram.';
      case err.status === 404:
        return 'Запись не найдена — возможно, её уже удалили.';
      case err.status === 409:
        return 'Это уже выполнено.';
      case err.status === 422 || err.status === 400:
        return 'Данные не приняты. Проверьте сумму и поля.';
      case err.status === 429:
        return 'Слишком часто. Подождите немного и повторите.';
      case err.status >= 500:
        return `${fallback}: сервер не ответил. Попробуйте ещё раз.`;
      default:
        return fallback;
    }
  }
  // fetch бросает TypeError, когда сети нет вовсе. Формулировка важна: это
  // не «ошибка приложения», и повторять запрос до восстановления связи бесполезно.
  if (err instanceof TypeError) {
    return 'Нет связи. Проверьте интернет и повторите.';
  }
  return fallback;
}
